module.exports = __webpack_public_path__ + "media/Start_Live_Session.08210243.mp4";